import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

function MainMeta() {
    const { i18n } = useTranslation();
    const descriptions = {
        ua: "Український ресторан БОРЩ, місто Алкмар, Нідерланди. Смачно та корисно.",
        en: "Ukrainian restaurant Borscht, Alkmaar, the Netherlands. Healthy and tasty food.",
        nl: "Oekraïens restaurant Borscht, Alkmaar, Nederland. Lekker en gezond eten.",
    };
    const title = {
        ua: "Борщ - Український ресторан",
        en: "Borscht – Ukrainian restaurant",
        nl: "Borscht – Oekraïens restaurant",
    }

    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    useEffect(() => {
        const handleLanguageChange = () => setCurrentLanguage(i18n.language);

        i18n.on('languageChanged', handleLanguageChange); // Слушаем изменения языка

        return () => {
            i18n.off('languageChanged', handleLanguageChange); // Очищаем слушатель
        };
    }, [i18n]);

    return (
        <Helmet>
            <title>{title[currentLanguage] || title.en}</title>
            <meta name="description" content={descriptions[currentLanguage] || descriptions.en} />
        </Helmet>
    );
}

export default MainMeta;